const data = [
  {
    home_page: {
      title: "Home - Berlin Technovation – Best IT Training Institute in Salem | Cyber Security, Data Analytics, Python and more.",
      meta: {
        meta1: {
          name: "description",
          content: "Berlin Technovation offers Salem’s best IT training in Cyber Security, Python, Data Analytics, Power BI, Oracle SQL, Snowflake & ETL, and Software Testing with placement support.",
        },
      },
    },
    about_page: {
      title: "About Us - About Berlin Technovation – Shaping IT Careers in Salem",
      meta: {
        meta1: {
          name: "description",
          content:
            "Berlin Technovation empowers students with expert training in Cyber Security, Data Analytics, Power BI, Oracle SQL, Python, Snowflake & ETL, and Software Testing.",
        },
      },
    },
    course_page: {
      title: "Courses - IT Training for Students, Career Switchers & Professionals | Berlin Technovation Salem",
      meta: {
        meta1: {
          name: "description",
          content:
            "Berlin Technovation offers hands-on IT courses for college students, non-IT to IT job seekers, and working professionals. Learn in-demand skills with expert-led training.",
        },
      },
    },

    placement_page: {
      title: "Placements - IT Training and Placement Assistance in Salem | Berlin Technovation",
      meta: {
        meta1: {
          name: "description",
          content:
            "Berlin Technovation offers 100% placement support for college students, non-IT to IT job seekers, and working professionals. Build skills and secure your dream IT job.",
        },
      },
    },
    internship_page: {
      title: "Internship - IT Internships in Salem | Berlin Technovation – Job-Oriented Training",
      meta: {
        meta1: {
          name: "description",
          content:
            "Gain real-world experience with Berlin Technovation’s IT internships in Salem. For college students, non-IT to IT job seekers, and working professionals.",
        },
      },
    },
    contactus_page: {
      title: " Salem’s Best IT Training Institute | Contact Berlin Technovation",
      content:
        "Contact Salem’s best IT training institute – Berlin Technovation. Learn Cyber Security, Python, Data Analytics & more with expert trainers and placement support.",

      meta: {
        meta1: {
          name: "description",
          content:
            "Join Salem’s best IT training programs at Berlin Technovation. Learn Cyber Security, Python, Data Analytics & more with hands-on projects and expert trainers.",
        },
      },
    },
    cookieContent:
      "We use cookies to improve your experience, analyze site traffic, and personalize content. By continuing, you agree to our Cookie Policy.",
  },
  
];

export default data;